import { page } from "$app/stores";
import { get } from "svelte/store";

export function findMetaobjectByTypeAndHandle(type: string, handle: string) {
  return get(page)?.data?.metaObjects?.[type]?.edges?.find((item: any) => item.node.handle === handle)?.node
}

export function findMachineTypeByHandle(handle: string) {
  return findMetaobjectByTypeAndHandle("machine_types", handle);
}
export function findTastingNoteByHandle(handle: string) {
  return findMetaobjectByTypeAndHandle("tasting_notes", handle);
}